import { render, staticRenderFns } from "./AddToClassrooms.vue?vue&type=template&id=0dafa0f6&scoped=true&"
import script from "./AddToClassrooms.vue?vue&type=script&lang=ts&"
export * from "./AddToClassrooms.vue?vue&type=script&lang=ts&"
import style0 from "./AddToClassrooms.vue?vue&type=style&index=0&id=0dafa0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafa0f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0dafa0f6', component.options)
    } else {
      api.reload('0dafa0f6', component.options)
    }
    module.hot.accept("./AddToClassrooms.vue?vue&type=template&id=0dafa0f6&scoped=true&", function () {
      api.rerender('0dafa0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/AddToClassrooms.vue"
export default component.exports